'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = require('react');
var React__default = _interopDefault(React);
var componentsLoader = require('@keytrade/components-loader');
var PropTypes = _interopDefault(require('prop-types'));
var componentsScrollcontainer = require('@keytrade/components-scrollcontainer');
var componentsTitletooltip = require('@keytrade/components-titletooltip');
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var FontDarkColor = colors.GreyMedium;
var StyledLoadingContainer = styled.div.withConfig({
  displayName: "Tablestyled__StyledLoadingContainer",
  componentId: "sc-sn807g-0"
})(["background:", ";display:flex;justify-content:center;align-items:center;padding:2rem;"], colors.White);
var StyledEmptyWrapper = styled.div.withConfig({
  displayName: "Tablestyled__StyledEmptyWrapper",
  componentId: "sc-sn807g-1"
})(["flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2.5rem 10rem;> span{color:", ";font-size:1.2rem;font-family:", ";}"], colors.BlueDark, function (_ref) {
  var theme = _ref.theme;
  return getFont(theme, 'semiBold');
});
var StyledScrollButton = styled.div.withConfig({
  displayName: "Tablestyled__StyledScrollButton",
  componentId: "sc-sn807g-2"
})(["", " position:absolute;z-index:100;top:0;width:1.8rem;height:2.8rem;margin:0.3rem;background-color:", ";border-radius:0.3rem;cursor:pointer;", ";", ""], function (props) {
  return props.isAlternateDesign && 'display: none !important;';
}, colors.GreyBright, function (_ref2) {
  var left = _ref2.left;
  return left ? 'left: 0' : 'right: 0';
}, function (_ref3) {
  var isHidden = _ref3.isHidden;
  return isHidden && "display: none;";
});
var StyledHeaderCell = styled.th.withConfig({
  displayName: "Tablestyled__StyledHeaderCell",
  componentId: "sc-sn807g-3"
})(["padding:", ";color:", ";font-size:", ";white-space:", ";height:3.4rem;font-family:", ";line-height:1.29;text-align:", ";", " ", " ", " &:first-of-type{font-family:", ";font-size:", ";color:", ";border-top-left-radius:", ";", " ", ";}&:last-of-type{border-top-right-radius:", ";", "}&:after{", " ", "}", ";", " > span{display:inline;}", " ", ""], function (props) {
  return props.isAlternateDesign ? '2.5rem 3rem' : props.isCompact ? '0 1.4rem' : '0 1.6rem';
}, function (props) {
  return props.isAlternateDesign ? props.theme.dark ? FontDarkColor : colors.GreyBlue : colors.BlueDark;
}, function (props) {
  return props.isAlternateDesign ? '1.8rem' : '1.2rem';
}, function (props) {
  return props.isAlternateDesign && 'nowrap';
}, function (_ref4) {
  var theme = _ref4.theme;
  return getFont(theme, 'bold');
}, function (_ref5) {
  var textAlign = _ref5.textAlign,
    isLight = _ref5.isLight,
    isAlternateDesign = _ref5.isAlternateDesign;
  return isAlternateDesign ? 'center' : textAlign ? textAlign : isLight ? 'center' : 'left';
}, function (_ref6) {
  var sortable = _ref6.sortable;
  return sortable && 'cursor: pointer;';
}, function (props) {
  return props.isLight && !props.isAlternateDesign && "\n        border: 1px solid ".concat(props.theme.dark ? colors.BlueDark : colors.GreyLight, ";\n        border-bottom: none;\n        border-left: none;\n        &:first-of-type{\n          border-left: 1px solid ").concat(props.theme.dark ? colors.BlueDark : colors.GreyLight, ";\n        }\n  ");
}, function (props) {
  return props.isLight && props.maxHeight && !props.isAlternateDesign && "\n    border-top: none;\n    &:first-of-type{\n      border-left: none;\n    }\n    &:last-of-type{\n      border-right: none;\n    }\n  ";
}, function (_ref7) {
  var theme = _ref7.theme,
    isAlternateDesign = _ref7.isAlternateDesign;
  return isAlternateDesign && getFont(theme, 'bold');
}, function (props) {
  return props.isAlternateDesign ? '2rem' : '1.2rem';
}, function (props) {
  return props.isAlternateDesign ? props.theme.dark ? colors.White : colors.BlueDark : colors.BlueDark;
}, function (props) {
  return props.isAlternateDesign ? '2.4rem' : '0.4rem';
}, function (props) {
  return !props.isLight && !props.isAlternateDesign && "\n      border-bottom-left-radius: 0.4rem;\n    ";
}, function (_ref8) {
  var stickyFirstColumn = _ref8.stickyFirstColumn,
    isAlternateDesign = _ref8.isAlternateDesign;
  return stickyFirstColumn && "\n      position: sticky;\n      z-index: 10;\n      left: 0;\n      background-color:  ".concat(isAlternateDesign ? colors.White : colors.GreyWhite, ";\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: -1.2rem;\n        height: 100%;\n        width: 1.2rem;\n        background: linear-gradient(to right, ").concat(colors.BlackTransparentLight, ", transparent);\n      }\n    ");
}, function (props) {
  return props.isAlternateDesign ? '2.4rem' : '0.4rem';
}, function (props) {
  return !props.isLight && !props.isAlternateDesign && "\n      border-bottom-right-radius: 0.4rem;\n    ";
}, function (_ref9) {
  var sortable = _ref9.sortable,
    isAlternateDesign = _ref9.isAlternateDesign;
  return !isAlternateDesign && sortable && "\n      content: '';\n      border-color: ".concat(colors.Transparent, " ").concat(colors.Transparent, " ").concat(colors.GreyBlue, ";\n      border-style: solid;\n      border-width: 0 0.38rem 0.72rem;\n      display: inline-block;\n      margin-left: .54rem;\n      margin-right: -1.6rem;\n      border-radius: 0.2rem;\n    ");
}, function (_ref10) {
  var active = _ref10.active,
    desc = _ref10.desc;
  return active && desc && "transform: rotate(180deg);";
}, function (_ref11) {
  var active = _ref11.active;
  return !active && "\n      &:after {\n        opacity: 0;\n      }\n      &:hover:after {\n        opacity: .5;\n      }\n    ";
}, function (props) {
  return props.width && "width: ".concat(props.width, "; max-width: ").concat(props.width, ";");
}, function (props) {
  return props.width && "width: ".concat(props.width, "; max-width: ").concat(props.width, ";");
}, function (props) {
  return props.theme.dark && "\n      &:first-of-type{\n        font-family: ".concat(getFont(props.theme, 'bold'), ";\n        font-size: 2rem;\n        color: white;\n      }\n      background-color: ").concat(colors.BlueMoon, " !important;\n      color: ").concat(FontDarkColor, ";\n  ");
});
var StyledWrapper = styled.div.withConfig({
  displayName: "Tablestyled__StyledWrapper",
  componentId: "sc-sn807g-4"
})(["margin:", ";flex:1;display:flex;flex-direction:column;overflow:auto;"], function (props) {
  return props.margin;
});
var StyledInnerWrapper = styled.div.withConfig({
  displayName: "Tablestyled__StyledInnerWrapper",
  componentId: "sc-sn807g-5"
})(["overflow-x:", ";", " ", " ", ""], function (props) {
  return props.isAlternateDesign && 'auto';
}, function (props) {
  return props.maxHeight && "max-height: ".concat(props.maxHeight, ";");
}, function (props) {
  return props.maxHeight && "overflow: auto;";
}, function (props) {
  return props.maxHeight && props.isLight && "\n      border-radius: .4rem;\n      border: 1px solid ".concat(colors.GreyLight, ";\n  ");
});
var StyledTable = styled.table.withConfig({
  displayName: "Tablestyled__StyledTable",
  componentId: "sc-sn807g-6"
})(["", " border-radius:", ";overflow:", ";width:100%;border-spacing:0;", " thead{tr{vertical-align:middle;}th{background:", ";", " font-weight:normal;}}tbody{background:", ";}tr{vertical-align:top;overflow:hidden;}"], function (props) {
  return props.isLight && "\n    border-collapse: separate;\n  ";
}, function (props) {
  return props.isAlternateDesign ? '2.4rem' : '0.4rem';
}, function (props) {
  return props.isAlternateDesign && 'hidden';
}, function (_ref12) {
  var fixed = _ref12.fixed;
  return fixed && 'table-layout: fixed;';
}, colors.GreyWhite, function (props) {
  return props.stickyHeader && "\n        position: sticky;\n        top: 0;\n        z-index: 10;\n      ";
}, function (props) {
  return !props.theme.dark && colors.White;
});
var StyledTableHead = styled.thead.withConfig({
  displayName: "Tablestyled__StyledTableHead",
  componentId: "sc-sn807g-7"
})(["", ""], function (props) {
  return props.hideHeader && "\n    border: 0;\n    clip: rect(.1rem, .1rem, .1rem, .1rem);\n    height: .1rem;\n    margin: -.1rem;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: .1rem;\n    white-space: nowrap;\n  ";
});
var sortable = function sortable(a, b) {
  if (a === null || a === undefined) {
    return 1;
  }
  if (b === null || b === undefined) {
    return -1;
  }
  var valueA = typeof a === 'string' ? a.toLowerCase() : a;
  var valueB = typeof b === 'string' ? b.toLowerCase() : b;
  if (valueA > valueB) return -1;
  if (valueA < valueB) return 1;
  return 0;
};
var TableLoading = function TableLoading() {
  return /*#__PURE__*/React__default.createElement(StyledLoadingContainer, null, /*#__PURE__*/React__default.createElement(componentsLoader.LoaderSpinner, null));
};
var colors$1 = functions.config.colors.list;
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.8rem",
    height: "2.8rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: colors$1.BlueSky,
    fillRule: "evenodd",
    d: "M8.177 11.88l5.89 5.844a.597.597 0 0 0 .85 0l.355-.358a.609.609 0 0 0 0-.856l-5.115-5.06 5.11-5.058a.609.609 0 0 0 0-.857l-.355-.357a.597.597 0 0 0-.85 0l-5.89 5.845c-.23.236-.23.62.005.856z"
  }));
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.8rem",
    height: "2.8rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: colors$1.BlueSky,
    fillRule: "evenodd",
    d: "M16.271 11.88l-5.89 5.844a.597.597 0 0 1-.85 0l-.355-.358a.609.609 0 0 1 0-.856l5.115-5.06-5.11-5.058a.609.609 0 0 1 0-.857l.355-.357a.597.597 0 0 1 .85 0l5.89 5.845c.23.236.23.62-.005.856z"
  }));
};
var ImgSearch = function ImgSearch(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10rem",
    height: "10rem",
    viewBox: "0 0 100 80"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "a",
    d: "M0 .053h1.72v1.684H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "c",
    d: "M0 53.97h64.869V0H0z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(13 13)"
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M13.751 8.97L14.811.7c.036-.276.314-.475.62-.443l33.513 3.506c.306.032.526.283.491.56l-.264 2.499M18.142 3.961l27.79 2.902M17.584 6.863l21.384 2.233"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2F8FE",
    d: "M38.144 48.782c-.23-.941.366-1.898 1.33-2.138.965-.24 1.933.328 2.162 1.27.23.94-.366 1.897-1.33 2.137-.964.24-1.932-.329-2.162-1.27"
  }), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(0 15.868)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2F8FE",
    d: "M.024 1.103A.855.855 0 0 1 .66.079a.846.846 0 0 1 1.035.608.855.855 0 0 1-.637 1.024.847.847 0 0 1-1.035-.608",
    mask: "url(#b)"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2F8FE",
    d: "M53.51 3.12h-.644v-.648a.243.243 0 0 0-.24-.244.243.243 0 0 0-.242.244v.648h-.643a.243.243 0 0 0 0 .487h.643v.649c0 .134.109.243.241.243.133 0 .241-.11.241-.243v-.649h.643a.243.243 0 0 0 0-.487M5.04 12.921H3.904v-1.148a.43.43 0 0 0-.426-.43.43.43 0 0 0-.427.43v1.148H1.912a.43.43 0 0 0 0 .862H3.05v1.148c0 .237.192.43.427.43a.43.43 0 0 0 .426-.43v-1.148h1.138a.43.43 0 0 0 0-.862M44.373 43.999v-1.723c0-.15.162-.245.291-.17l1.478.862 1.478.861c.13.076.13.264 0 .34l-1.478.86-1.478.862a.194.194 0 0 1-.291-.17V44z"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M8.187 14.686h2.708V10.73H8.187zM15.729 38.13s-7.438-2.141-8.25-8.899l-.036-12.905-2.128-.028.125 14.412s1.497 6.64 10.91 8.2l-.622-.78z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M18.26 41.249h10.397M10.33 14.395V10.64a1.78 1.78 0 0 1 1.77-1.788h26.465v-.636a1.78 1.78 0 0 1 1.772-1.789h10.967c.978 0 1.772.801 1.772 1.789v13.336",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M36.001 14.491H9.223c-.979 0-1.772.8-1.772 1.788V29.56s.995 8.707 10.285 8.707h17.127",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M28.032 26.627c0-7.247 5.82-13.122 13-13.122s13 5.875 13 13.122-5.82 13.121-13 13.121-13-5.874-13-13.121z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M31.635 26.627c0-5.238 4.207-9.485 9.397-9.485s9.396 4.247 9.396 9.485c0 5.238-4.207 9.484-9.396 9.484-5.19 0-9.397-4.246-9.397-9.484z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00B3DB",
    d: "M63.302 52.655a2.733 2.733 0 0 1-3.88-.266l-8.574-9.918a.72.72 0 0 1 .068-1.01l3.076-2.71a.704.704 0 0 1 1 .07l8.574 9.918a2.794 2.794 0 0 1-.264 3.916",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M63.302 52.655a2.733 2.733 0 0 1-3.88-.266l-8.574-9.918a.72.72 0 0 1 .068-1.01l3.076-2.71a.704.704 0 0 1 1 .07l8.574 9.918a2.794 2.794 0 0 1-.264 3.916z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M50.49 35.82l2.958 3.422-1.978 1.741-2.959-3.422",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M47.814 32.162H38.63a.712.712 0 0 1-.708-.715v-9.27c0-.394.317-.714.708-.714h9.184c.391 0 .708.32.708.715v9.27a.712.712 0 0 1-.708.714",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M47.814 32.162H38.63a.712.712 0 0 1-.708-.715v-9.27c0-.394.317-.714.708-.714h9.184c.391 0 .708.32.708.715v9.27a.712.712 0 0 1-.708.714z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#2C3B45",
    d: "M42.3 28.916c0-.207.056-.363.165-.47.11-.105.27-.158.48-.158.203 0 .36.054.47.162.112.109.167.264.167.466 0 .195-.056.348-.168.46-.112.112-.269.168-.469.168-.205 0-.364-.055-.476-.164-.112-.11-.168-.264-.168-.464zm.118-1.264v-.274c0-.236.05-.442.15-.617.1-.175.283-.361.55-.558.256-.185.425-.335.506-.451a.658.658 0 0 0 .123-.388.421.421 0 0 0-.176-.366c-.117-.084-.28-.126-.49-.126-.367 0-.784.12-1.253.362l-.399-.81a3.462 3.462 0 0 1 1.732-.461c.503 0 .903.122 1.2.366.296.244.445.57.445.976 0 .27-.062.505-.184.702-.122.197-.354.419-.695.665-.235.175-.383.308-.445.4a.623.623 0 0 0-.094.358v.222h-.97z",
    mask: "url(#d)"
  })));
};
var ImgNoResults = function ImgNoResults(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10rem",
    height: "10rem",
    viewBox: "0 0 100 80"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M60.301 31.212c.359-.16.794-.241 1.305-.241.787 0 1.396.21 1.829.629.43.419.646 1.02.646 1.8 0 .753-.217 1.347-.654 1.78-.436.433-1.043.65-1.821.65-.487 0-.907-.08-1.259-.238l-.046-4.38zm-.744-2.7v-1.057c0-.915.194-1.71.583-2.387.39-.676 1.1-1.395 2.135-2.158.996-.714 1.652-1.295 1.97-1.743.317-.448.477-.948.477-1.5 0-.62-.228-1.091-.683-1.415-.455-.324-1.09-.486-1.907-.486-1.422 0-3.044.467-4.866 1.4l-1.55-3.13c2.115-1.19 4.358-1.786 6.73-1.786 1.953 0 3.506.472 4.66 1.415 1.15.943 1.728 2.2 1.728 3.773 0 1.048-.238 1.953-.712 2.715-.474.762-1.375 1.62-2.703 2.573-.91.676-1.487 1.19-1.728 1.543-.243.352-.364.815-.364 1.386v.858h-3.77z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M41.326 17.377c-8.914 0-16.14 7.456-16.14 16.653 0 9.196 7.226 16.652 16.14 16.652 2.813 0 5.458-.742 7.76-2.048 0 0-20.448 2.362-20.758-14.005-.327-17.247 12.998-17.252 12.998-17.252"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2F8FE",
    d: "M28.323 47.047a.788.788 0 0 1-.8.776.788.788 0 0 1-.798-.776c0-.428.358-.775.799-.775.441 0 .799.347.799.775M21.416 44.732c-.286-1.162.454-2.345 1.651-2.64 1.197-.297 2.399.405 2.684 1.567.285 1.162-.454 2.344-1.652 2.64-1.196.297-2.398-.405-2.683-1.567M65.946 36.134h-.798v-.802a.3.3 0 0 0-.3-.3.3.3 0 0 0-.298.3v.802h-.799a.301.301 0 0 0 0 .601h.799v.802a.3.3 0 0 0 .299.3.3.3 0 0 0 .299-.3v-.802h.798a.3.3 0 0 0 0-.601M50.595 53.027h-1.353v-1.36a.51.51 0 0 0-.508-.51.51.51 0 0 0-.508.51v1.36h-1.353a.51.51 0 0 0 0 1.02h1.353v1.359c0 .28.229.51.508.51a.51.51 0 0 0 .508-.51v-1.36h1.353a.51.51 0 0 0 0-1.019M17 41.852v-1.429c0-.125.135-.203.243-.14l1.231.713 1.232.715a.163.163 0 0 1 0 .281l-1.232.714-1.231.714a.162.162 0 0 1-.243-.14V41.85z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M28.086 32.882c0-8.86 7.15-16.043 15.971-16.043 8.82 0 15.972 7.183 15.972 16.043s-7.151 16.043-15.972 16.043c-8.82 0-15.971-7.183-15.971-16.043z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M32.513 32.882c0-6.404 5.168-11.596 11.544-11.596s11.544 5.192 11.544 11.596-5.168 11.596-11.544 11.596-11.544-5.192-11.544-11.596z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00B3DB",
    d: "M71.9 64.282l-.966.846a2.73 2.73 0 0 1-3.862-.264L56.007 52.128a.711.711 0 0 1 .068-1l4.029-3.53a.704.704 0 0 1 .995.067l11.064 12.737a2.759 2.759 0 0 1-.263 3.88"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M71.9 64.282l-.966.846a2.73 2.73 0 0 1-3.862-.264L56.007 52.128a.711.711 0 0 1 .068-1l4.029-3.53a.704.704 0 0 1 .995.067l11.064 12.737a2.759 2.759 0 0 1-.263 3.88z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.676 44.121l3.635 4.184-2.43 2.13-3.635-4.184"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M70.545 53.72l-5.357-5.869"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M53.064 25.83s5.384 4.708.414 13.254h-12.27a.873.873 0 0 1-.87-.874V26.877c0-.483.39-.875.87-.875h11.963"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M53.064 25.83s5.384 4.708.414 13.254h-12.27a.873.873 0 0 1-.87-.874V26.877c0-.483.39-.875.87-.875h11.963"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#2C3B45",
    d: "M46.23 35.424c0-.253.067-.445.202-.574.135-.13.332-.195.59-.195.249 0 .441.067.578.2.136.132.204.322.204.569 0 .238-.068.425-.206.562-.139.137-.33.206-.576.206-.252 0-.447-.067-.585-.2-.138-.135-.207-.324-.207-.568zm.144-1.546v-.334c0-.29.061-.541.184-.755.123-.214.348-.441.675-.683.315-.225.523-.41.623-.55a.8.8 0 0 0 .151-.475.515.515 0 0 0-.216-.448c-.144-.102-.345-.153-.603-.153-.45 0-.963.147-1.539.443l-.49-.99a4.27 4.27 0 0 1 2.128-.565c.618 0 1.11.15 1.474.447.364.299.546.696.546 1.193 0 .332-.075.618-.225.859-.15.241-.435.512-.855.813-.288.214-.47.377-.546.488a.758.758 0 0 0-.115.439v.271h-1.192z"
  })));
};
var ImgFileBroken = function ImgFileBroken(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10rem",
    height: "10rem",
    viewBox: "0 0 100 80"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "a",
    d: "M6.126.291L4.42 3.912.776 2.218a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347L3.9 5.014 2.815 7.32l1.264.187.931-1.977 3.645 1.694a.263.263 0 0 0 .35-.126l.296-.629a.26.26 0 0 0-.127-.347L5.53 4.428 7.235.808A.26.26 0 0 0 7.108.46L6.475.165a.263.263 0 0 0-.35.126z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(37.188 15.135)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".55",
    d: "M-3.499.903L8.56-3.44l4.37 11.978L.873 12.881z",
    mask: "url(#b)"
  })), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".55",
    d: "M41.268 22.642l.93-1.978 3.645 1.695a.263.263 0 0 0 .35-.126l.296-.63a.26.26 0 0 0-.127-.346l-3.644-1.695 1.705-3.62a.26.26 0 0 0-.126-.347l-.634-.295a.263.263 0 0 0-.35.126l-1.704 3.621-3.645-1.694a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347l3.644 1.694-1.085 2.305 1.264.188zM65.48 39.971c.215.057.547.175.774.356.348.279.543.586.587.923.041.336-.076.675-.353 1.017-.267.33-.685.512-1.031.547l.023-2.843zm.517-1.285l.357-.477c.308-.413.665-.707 1.07-.882.406-.174.973-.26 1.702-.256.695.012 1.19-.03 1.486-.125a1.43 1.43 0 0 0 .724-.517c.208-.28.263-.57.165-.868-.099-.3-.334-.587-.707-.861-.65-.478-1.547-.813-2.693-1.004l.347-1.934a7.731 7.731 0 0 1 3.674 1.456c.892.657 1.442 1.392 1.65 2.206.208.813.047 1.574-.482 2.284-.353.473-.767.802-1.24.987-.473.185-1.173.269-2.1.252-.644 0-1.08.038-1.31.116-.23.078-.44.245-.633.504l-.288.387-1.722-1.268z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M31.759 45.964l-.038-21.91 1.664-1.321-1.338-.173c-1.568 0-2.839.953-2.839 2.128v21.276l-.003-.103c0 .801.442 1.537 1.154 1.917 0 0 3.525 1.06 4.024.757.499-.303-1.22-.716-1.22-.716l-1.404-1.855M31.583 50.937l.25 9.48 1.136 1.247 2.29.337c-.38 0-3.959-.048-4.29-.136-1.035-.27-1.764-.923-1.764-1.683v-1.238l.003-.28v-7.23s-.351-.366 2.375-.497"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.946 28.213v17.75l.005-.102c0 .801-.443 1.537-1.154 1.916a2.208 2.208 0 0 1-2.259-.098l-1.711-1.121a.504.504 0 0 0-.538.002l-1.37.895a3.813 3.813 0 0 1-2.097.627 3.81 3.81 0 0 1-2.096-.625l-1.37-.897a.503.503 0 0 0-.537.002l-1.371.895a3.818 3.818 0 0 1-4.19 0l-1.37-.897a.506.506 0 0 0-.54.002l-1.37.895a3.818 3.818 0 0 1-4.188 0l-1.371-.897a.506.506 0 0 0-.54.002l-1.71 1.117a2.223 2.223 0 0 1-2.26.1 2.173 2.173 0 0 1-1.153-1.918l.003.103V24.688c0-1.175 1.27-2.128 2.838-2.128h24.295l6.054 5.653z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#AEEDFC",
    d: "M59.108 23v2.946c0 .89.729 1.653 1.763 1.97.332.103.695.159 1.076.159h2.518"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.65",
    d: "M59.108 23v2.946c0 .89.729 1.653 1.763 1.97.332.103.695.159 1.076.159h2.518L59.108 23z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.591 66.032H38.62M64.943 59.47v1.59c0 1.289-1.27 2.334-2.839 2.334h-27.51a3.37 3.37 0 0 1-1.076-.173c-1.034-.349-1.762-1.185-1.762-2.162V59.47l.003-.36v-8.07l-.003-.113c0 .88.44.472 1.153.89a2.056 2.056 0 0 0 2.26-.108l1.71-1.226a.468.468 0 0 1 .54-.002l1.37.983a3.54 3.54 0 0 0 4.19 0l1.37-.981a.468.468 0 0 1 .539-.002l1.37.983a3.54 3.54 0 0 0 4.19 0l1.37-.981a.465.465 0 0 1 .538-.002l1.37.983a3.571 3.571 0 0 0 2.096.686c.729 0 1.459-.228 2.096-.687l1.371-.982a.465.465 0 0 1 .538-.002l1.711 1.23c.68.486 1.546.53 2.26.106.71-.416 1.153-.009 1.153-.888l-.005.114v8.07l-.003.36z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2F8FE",
    d: "M66.34 22.905c-.201-.81.32-1.635 1.164-1.841.844-.207 1.691.282 1.892 1.093.2.81-.32 1.634-1.164 1.84-.844.207-1.691-.282-1.892-1.092M64.613 24.713c-.111-.449.177-.905.645-1.02.467-.114.936.157 1.047.606.111.448-.177.905-.644 1.02-.468.113-.937-.158-1.048-.606M67.667 29.645c-.111-.449.177-.905.644-1.02.468-.114.937.157 1.048.606.11.448-.178.905-.645 1.019-.467.114-.936-.157-1.047-.605M23.235 31.738c-.2-.81.32-1.634 1.165-1.84.844-.207 1.69.282 1.892 1.092.2.81-.32 1.635-1.165 1.841-.844.207-1.69-.282-1.892-1.093M21.024 34.124c-.111-.448.177-.905.644-1.02.468-.113.937.157 1.048.606.11.449-.178.905-.645 1.02-.467.114-.936-.157-1.047-.606M64.337 20.247h-1.151v-1.143a.431.431 0 0 0-.863 0v1.143h-1.151a.432.432 0 0 0-.432.428c0 .236.194.43.432.43h1.15v1.143a.432.432 0 0 0 .864 0v-1.144h1.15a.432.432 0 0 0 .432-.429.431.431 0 0 0-.431-.428M71.334 60.157l-1.093-1.086 1.093-1.087a.575.575 0 0 0 0-.815.584.584 0 0 0-.82 0l-1.094 1.087-1.094-1.087a.584.584 0 0 0-.82 0 .575.575 0 0 0 0 .815L68.6 59.07l-1.094 1.086a.575.575 0 0 0 0 .815.584.584 0 0 0 .82 0l1.094-1.086 1.094 1.086a.584.584 0 0 0 .82 0 .575.575 0 0 0 0-.815M28.47 62.22h-.93v-.923a.349.349 0 0 0-.697 0v.924h-.93a.349.349 0 0 0-.349.346c0 .191.157.347.349.347h.93v.924a.349.349 0 0 0 .697 0v-.924h.93a.349.349 0 0 0 .349-.347.349.349 0 0 0-.349-.346M24.552 37.284v-1.715c0-.15.164-.244.295-.17l1.495.858 1.495.858a.195.195 0 0 1 0 .338l-1.495.857-1.495.858a.197.197 0 0 1-.295-.17v-1.714zM65.52 63.2v-1.152c0-.1.11-.164.197-.113l1.003.575 1.004.576a.13.13 0 0 1 0 .227l-1.004.575-1.003.576a.132.132 0 0 1-.198-.114V63.2z"
  }), /*#__PURE__*/React__default.createElement("g", {
    fill: "#00B3DB",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M51.204 36l3.225 3.225a1.097 1.097 0 0 1 0 1.551l-.653.652a1.096 1.096 0 0 1-1.551 0L49 38.205l-3.225 3.224c-.428.43-1.123.43-1.551 0l-.653-.652a1.097 1.097 0 0 1 0-1.551L46.796 36l-3.225-3.225a1.097 1.097 0 0 1 0-1.551l.653-.652a1.096 1.096 0 0 1 1.551 0L49 33.795l3.225-3.224a1.097 1.097 0 0 1 1.551 0l.653.652a1.097 1.097 0 0 1 0 1.551L51.204 36z"
  }))));
};
var renderIcon = function renderIcon(icon) {
  switch (icon) {
    case 'img_search':
      return /*#__PURE__*/React__default.createElement(ImgSearch, null);
    case 'img_noResults':
      return /*#__PURE__*/React__default.createElement(ImgNoResults, null);
    case 'img_fileBroken':
    default:
      return /*#__PURE__*/React__default.createElement(ImgFileBroken, null);
  }
};
var EmptyView = function EmptyView(_ref) {
  var renderEmpty = _ref.renderEmpty,
    labelEmpty = _ref.labelEmpty,
    iconEmpty = _ref.iconEmpty;
  if (renderEmpty) return renderEmpty();
  return /*#__PURE__*/React__default.createElement(StyledEmptyWrapper, null, iconEmpty && renderIcon(iconEmpty), /*#__PURE__*/React__default.createElement("span", null, labelEmpty));
};
EmptyView.propTypes = {
  /** Sets the text for an empty table  */
  labelEmpty: PropTypes.string,
  /** Sets the icon above the text for an empty table  */
  iconEmpty: PropTypes.oneOf(['img_search', 'img_noResults', 'img_fileBroken']),
  /** Sets a custom renderer for the empty state of a table */
  renderEmpty: PropTypes.func
};
EmptyView.defaultProps = {
  labelEmpty: 'No data found',
  iconEmpty: null
};
var colors$2 = functions.config.colors.list;
var getFont$1 = functions.config.fonts.getFont;
var StyledBodyCell = styled.td.withConfig({
  displayName: "TableRowstyled__StyledBodyCell",
  componentId: "sc-1wp4sjh-0"
})(["background-color:", ";padding:", ";font-size:", ";height:", ";line-height:1.29;color:", ";text-align:", ";vertical-align:middle;> div{white-space:", ";", " margin:0;padding:0;}tr:first-of-type &,tr + tr &{", " ", " ", " ", "}tbody tr:last-of-type &:first-of-type{border-bottom-left-radius:", " !important;}tbody tr:last-of-type &:last-of-type{border-bottom-right-radius:", " !important;}", " &:first-of-type{font-family:", ";}", " ", " ", " ", " ", " &:first-of-type{position:relative;", " ", ";}&:last-of-type{position:relative;", "}", ";", ""], function (props) {
  return props.theme.dark ? colors$2.BlueMoon : colors$2.Transparent;
}, function (props) {
  return props.isAlternateDesign ? '2.5rem 3rem' : props.isCompact ? '.8rem' : '.8rem 1.6rem';
}, function (props) {
  return props.isAlternateDesign ? '1.6rem' : props.isCompact ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.hasCollapseElements ? '0' : 'auto';
}, function (props) {
  return props.theme.dark ? colors$2.White : colors$2.BlueDark;
}, function (_ref) {
  var textAlign = _ref.textAlign,
    isLight = _ref.isLight,
    isAlternateDesign = _ref.isAlternateDesign;
  return isAlternateDesign ? 'center' : textAlign ? textAlign : isLight ? 'center' : 'left';
}, function (props) {
  return props.isAlternateDesign ? 'nowrap' : 'normal';
}, function (_ref2) {
  var ellipsis = _ref2.ellipsis;
  return ellipsis && "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    ";
}, function (props) {
  return !props.hasCollapseElements && "\n        border-top: 0.1rem solid ".concat(props.theme.dark ? colors$2.BlueDark : colors$2.GreyWhite, ";\n    ");
}, function (props) {
  return !props.hideHeader && !props.customStyles && "position: relative";
}, function (props) {
  return !props.hideHeader && !props.isAlternateDesign && "\n      &:first-of-type::after{\n          content: '';\n          width: 1.6rem;\n          height: 0.1rem;\n          background-color: ".concat(props.theme.dark ? colors$2.BlueDark : colors$2.White, ";\n          position: absolute;\n          top: -0.1rem;\n          left: 0;\n      }\n    ");
}, function (props) {
  return !props.hideHeader && props.customStyles && "\n      &:first-of-type::after{ background: ".concat(props.customStyles['background-color'], "; }\n    ");
}, function (props) {
  return props.isAlternateDesign ? '2.4rem' : '0.4rem';
}, function (props) {
  return props.isAlternateDesign ? '2.4rem' : '0.4rem';
}, function (props) {
  return props.isLight && !props.isAlternateDesign && "\n        border: 1px solid ".concat(props.theme.dark ? colors$2.BlueDark : colors$2.GreyLight, ";\n        border-left: ").concat(props.theme.dark ? colors$2.BlueDark : colors$2.GreyLight, ";\n        &:first-of-type{\n          border-left: 1px solid ").concat(props.theme.dark ? colors$2.BlueDark : colors$2.GreyLight, ";\n        }\n        tr:last-of-type & {\n          border-bottom: 1px solid ").concat(props.theme.dark ? colors$2.BlueDark : colors$2.GreyLight, ";\n        }\n        tbody > tr  &:first-of-type::after {\n          content: none;\n        }\n        border-bottom: none;\n    ");
}, function (_ref3) {
  var theme = _ref3.theme,
    isAlternateDesign = _ref3.isAlternateDesign;
  return isAlternateDesign && getFont$1(theme, 'bold');
}, function (props) {
  return props.width && "width: ".concat(props.width, ";");
}, function (props) {
  return props.isLight && props.hideHeader && "\n      tbody > tr:first-of-type &:first-of-type {\n        border-top-left-radius: .4rem;\n      }\n      tbody > tr:first-of-type &:last-of-type {\n        border-top-right-radius: .4rem;\n      }\n     ";
}, function (props) {
  return props.isAlternateDesign && props.hideHeader && "\n      tbody > tr:first-of-type &:first-of-type {\n        border-top-left-radius: 2.4rem;\n      }\n      tbody > tr:first-of-type &:last-of-type {\n        border-top-right-radius: 2.4rem;\n      }\n     ";
}, function (props) {
  return props.isLight && !props.hideHeader && !props.isAlternateDesign && "\n      tbody > tr:first-of-type & {\n        border-top: none;\n      }\n     ";
}, function (props) {
  return props.theme.dark && !props.hideHeader && "\n      tbody > tr:first-of-type & {\n        border-top: 0.1rem solid ".concat(colors$2.BlueDark, ";\n      }\n     ");
}, function (props) {
  return props.hideHeader && !props.isLight && "\n      padding-left: 0;\n     ";
}, function (_ref4) {
  var stickyFirstColumn = _ref4.stickyFirstColumn;
  return stickyFirstColumn && "\n      left: 0;\n      background-color: ".concat(colors$2.White, ";\n      position: sticky;\n      z-index: 10;\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: -1.2rem;\n        height: 100%;\n        width: 1.2rem;\n        background: linear-gradient(to right, ").concat(colors$2.BlackTransparentLight, ", transparent);\n      }\n    ");
}, function (props) {
  return props.hideHeader && !props.isLight && 'padding-right: 0;';
}, function (_ref5) {
  var customStyles = _ref5.customStyles;
  return customStyles && customStyles;
}, function (props) {
  return props.isLight && props.maxHeight && !props.isAlternateDesign && !props.theme.dark && "\n    tr:first-of-type > & {\n      border-top: none;\n    }\n    tr:last-of-type > & {\n      border-bottom: none;\n    }\n    &:first-of-type{\n      border-left: none;\n    }\n    &:last-of-type{\n      border-right: none;\n    }\n  ";
});
var CollapseHeader = styled.tr.withConfig({
  displayName: "TableRowstyled__CollapseHeader",
  componentId: "sc-1wp4sjh-1"
})(["cursor:pointer;transition:background-color ease 0.2s;&:hover{background-color:", ";}"], colors$2.GreyWhite);
var CollapseContentInner = styled.div.withConfig({
  displayName: "TableRowstyled__CollapseContentInner",
  componentId: "sc-1wp4sjh-2"
})(["height:auto;overflow:", ";max-height:", ";", ""], function (props) {
  return props.isOpen ? 'auto' : 'hidden';
}, function (props) {
  return props.isOpen ? '50vh' : '0rem';
}, function (props) {
  return props.ianimateCollapse && 'transition: opacity 0.2s ease, max-height 0.4s ease;';
});
var CollapseContent = styled.tr.withConfig({
  displayName: "TableRowstyled__CollapseContent",
  componentId: "sc-1wp4sjh-3"
})(["& > td{padding:0;margin:0;border:none;}"]);
var TableRow = /*#__PURE__*/function (_PureComponent) {
  function TableRow() {
    _classCallCheck(this, TableRow);
    return _callSuper(this, TableRow, arguments);
  }
  _inherits(TableRow, _PureComponent);
  return _createClass(TableRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        animateCollapse = _this$props.animateCollapse,
        collapseData = _this$props.collapseData,
        collapseHandler = _this$props.collapseHandler,
        collapsibleRow = _this$props.collapsibleRow,
        columns = _this$props.columns,
        hideHeader = _this$props.hideHeader,
        isLight = _this$props.isLight,
        isOpen = _this$props.isOpen,
        lastRow = _this$props.lastRow,
        maxHeight = _this$props.maxHeight,
        originalIndex = _this$props.originalIndex,
        rowContent = _this$props.rowContent,
        rowKey = _this$props.rowKey,
        stickyFirstColumn = _this$props.stickyFirstColumn,
        isCompact = _this$props.isCompact,
        isAlternateDesign = _this$props.isAlternateDesign;
      if (collapsibleRow) {
        return /*#__PURE__*/React__default.createElement(CollapseContent, {
          hasCollapseElements: true,
          isOpen: isOpen,
          isAlternateDesign: isAlternateDesign
        }, /*#__PURE__*/React__default.createElement(StyledBodyCell, {
          hasCollapseElements: true,
          colSpan: columns.filter(function (column) {
            return !column.isHidden;
          }).length,
          isOpen: isOpen,
          hideHeader: hideHeader,
          isCompact: isCompact,
          isAlternateDesign: isAlternateDesign
        }, /*#__PURE__*/React__default.createElement(CollapseContentInner, {
          isOpen: isOpen,
          animateCollapse: animateCollapse,
          isAlternateDesign: isAlternateDesign
        }, rowContent)));
      } else {
        return collapseData ? /*#__PURE__*/React__default.createElement(CollapseHeader, {
          onClick: function onClick() {
            return collapseHandler(originalIndex);
          },
          isAlternateDesign: isAlternateDesign
        }, columns.filter(function (column) {
          return !column.isHidden;
        }).map(function (column, index) {
          return /*#__PURE__*/React__default.createElement(StyledBodyCell, {
            hideHeader: hideHeader,
            width: column.width,
            key: "".concat(rowKey, "-").concat(column.key),
            lastRow: lastRow,
            textAlign: column.textAlign,
            ellipsis: column.ellipsis,
            stickyFirstColumn: stickyFirstColumn,
            customStyles: column.style && column.style(rowContent[column.key], rowContent),
            isLight: isLight,
            maxHeight: maxHeight,
            isCompact: isCompact,
            isAlternateDesign: isAlternateDesign
          }, /*#__PURE__*/React__default.createElement("div", null, column.renderCell ? column.renderCell(rowContent[column.key], rowContent) : rowContent[column.key]));
        })) : /*#__PURE__*/React__default.createElement("tr", null, columns.filter(function (column) {
          return !column.isHidden;
        }).map(function (column, index) {
          return /*#__PURE__*/React__default.createElement(StyledBodyCell, {
            hideHeader: hideHeader,
            width: column.width,
            key: "".concat(rowKey, "-").concat(column.key),
            lastRow: lastRow,
            textAlign: column.textAlign,
            ellipsis: column.ellipsis,
            stickyFirstColumn: stickyFirstColumn,
            customStyles: column.style && column.style(rowContent[column.key], rowContent),
            isLight: isLight,
            maxHeight: maxHeight,
            isCompact: isCompact,
            isAlternateDesign: isAlternateDesign
          }, /*#__PURE__*/React__default.createElement("div", null, column.renderCell ? column.renderCell(rowContent[column.key], rowContent) : rowContent[column.key]));
        }));
      }
    }
  }]);
}(React.PureComponent);
TableRow.propTypes = {
  animateCollapse: PropTypes.bool,
  isCompact: PropTypes.bool,
  collapseData: PropTypes.bool,
  collapseHandler: PropTypes.func,
  collapsibleRow: PropTypes.bool,
  columns: PropTypes.array,
  hideHeader: PropTypes.bool,
  isLight: PropTypes.bool,
  isOpen: PropTypes.bool,
  lastRow: PropTypes.bool,
  maxHeight: PropTypes.string,
  originalIndex: PropTypes.number,
  rowContent: PropTypes.object,
  rowKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyFirstColumn: PropTypes.bool
};
var SCROLL_DISTANCE = 200;
var Table = /*#__PURE__*/function (_React$Component) {
  function Table(props) {
    var _this;
    _classCallCheck(this, Table);
    _this = _callSuper(this, Table, [props]);
    _defineProperty(_this, "setSortingKey", function (sortingKey) {
      var sortingColumn = _this.props.columns.find(function (column) {
        return column.key === sortingKey;
      });
      _this.setState(function (prevState) {
        return {
          sortingKey: sortingKey,
          sortDesc: prevState.sortingKey === sortingKey ? !prevState.sortDesc : sortingColumn.sortOptions && sortingColumn.sortOptions.desc,
          openRows: [],
          animateCollapse: false
        };
      }, function () {
        return _this.props.onSortChange(_this.state.sortingKey, _this.state.sortDesc);
      });
    });
    _defineProperty(_this, "sortData", function (data) {
      var columns = _this.props.columns;
      var _this$state = _this.state,
        sortingKey = _this$state.sortingKey,
        sortDesc = _this$state.sortDesc;
      var sortingColumn = columns.find(function (column) {
        return column.key === sortingKey;
      });
      var sortedData = data.slice();
      if (sortingColumn) {
        if (sortingColumn.isSortable) {
          sortedData.sort(function (a, b) {
            return sortable(a[sortingKey], b[sortingKey]);
          });
        }
        if (sortingColumn.sortOptions && sortingColumn.sortOptions.compareFunction) {
          sortedData.sort(function (a, b) {
            return sortingColumn.sortOptions.compareFunction(a[sortingKey], b[sortingKey]);
          });
        }
        if (sortDesc) {
          sortedData.reverse();
        }
      }
      return sortedData;
    });
    _defineProperty(_this, "collapseHandler", function (rowIndex) {
      var onCollapse = _this.props.onCollapse;
      _this.setState(function (prevState) {
        var newState = prevState;
        var index = prevState.openRows.indexOf(rowIndex);
        index === -1 ? newState.openRows.push(rowIndex) : newState.openRows.splice(index, 1);
        newState.animateCollapse = true;
        return newState;
      }, function () {
        return onCollapse(rowIndex);
      });
    });
    var sortColumn = props.columns.find(function (column) {
      return column.key === props.sortedOn;
    });
    _this.state = {
      sortingKey: props.sortedOn,
      sortDesc: !!(sortColumn && sortColumn.sortOptions && sortColumn.sortOptions.desc),
      openRows: props.expanded ? props.data.map(function (_, index) {
        return index;
      }) : [],
      animateCollapse: true
    };
    return _this;
  }
  _inherits(Table, _React$Component);
  return _createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.sortedOn !== this.props.sortedOn && prevState.sortingKey !== this.props.sortedOn) {
        this.setState({
          sortingKey: this.props.sortedOn
        });
      }
      if (prevProps.sortedDesc !== this.props.sortedDesc && prevState.sortDesc !== this.props.sortedDesc) {
        this.setState({
          sortDesc: this.props.sortedDesc
        });
      }
      if (prevProps.expanded !== this.props.expanded) {
        this.setState({
          openRows: this.props.expanded ? this.props.data.map(function (_, index) {
            return index;
          }) : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        isLight = _this$props.isLight,
        columns = _this$props.columns,
        isLoading = _this$props.isLoading,
        keyExtractor = _this$props.keyExtractor,
        fixed = _this$props.fixed,
        maxHeight = _this$props.maxHeight,
        renderEmpty = _this$props.renderEmpty,
        labelEmpty = _this$props.labelEmpty,
        iconEmpty = _this$props.iconEmpty,
        hideHeader = _this$props.hideHeader,
        stickyHeader = _this$props.stickyHeader,
        stickyFirstColumn = _this$props.stickyFirstColumn,
        data = _this$props.data,
        styledComponentsV4 = _this$props.styledComponentsV4,
        margin = _this$props.margin,
        isCompact = _this$props.isCompact,
        isAlternateDesign = _this$props.isAlternateDesign;
      var _this$state2 = this.state,
        sortingKey = _this$state2.sortingKey,
        sortDesc = _this$state2.sortDesc;
      var sortedData = this.sortData(data.map(function (item, index) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          originalIndex: index
        });
      })).map(function (element) {
        return {
          rowContent: Object.keys(element).filter(function (key) {
            return key !== 'collapseData';
          }).reduce(function (obj, key) {
            obj[key] = element[key];
            return obj;
          }, {}),
          originalIndex: element.originalIndex,
          collapseData: element.collapseData || null,
          collapsibleRow: false
        };
      });
      var sortedRows = [];
      sortedData.forEach(function (element, index) {
        sortedRows.push(element);
        element.collapseData && sortedRows.push({
          rowContent: element.collapseData,
          collapsibleRow: true
        });
      });
      return /*#__PURE__*/React__default.createElement(StyledWrapper, {
        className: className,
        margin: margin,
        isAlternateDesign: isAlternateDesign
      }, /*#__PURE__*/React__default.createElement(componentsScrollcontainer.ScrollContainer, {
        fullWidth: true,
        styledComponentsV4: styledComponentsV4,
        scrollDistance: SCROLL_DISTANCE,
        button: function button(props) {
          return /*#__PURE__*/React__default.createElement(StyledScrollButton, _extends({}, props, {
            isAlternateDesign: isAlternateDesign
          }), props.left ? /*#__PURE__*/React__default.createElement(ArrowLeft, null) : /*#__PURE__*/React__default.createElement(ArrowRight, null));
        },
        isAlternateDesign: isAlternateDesign
      }, /*#__PURE__*/React__default.createElement(StyledInnerWrapper, {
        maxHeight: maxHeight,
        isLight: isLight,
        isAlternateDesign: isAlternateDesign
      }, /*#__PURE__*/React__default.createElement(StyledTable, {
        fixed: fixed,
        stickyHeader: stickyHeader,
        isLight: isLight,
        isAlternateDesign: isAlternateDesign
      }, /*#__PURE__*/React__default.createElement(StyledTableHead, {
        hideHeader: hideHeader,
        isAlternateDesign: isAlternateDesign
      }, /*#__PURE__*/React__default.createElement("tr", null, columns.filter(function (column) {
        return !column.isHidden;
      }).map(function (column) {
        var isSortable = column.isSortable || !!column.sortOptions;
        return /*#__PURE__*/React__default.createElement(StyledHeaderCell, {
          maxHeight: maxHeight,
          isLight: isLight,
          width: column.width,
          key: column.key,
          active: column.key === sortingKey,
          desc: sortDesc,
          sortable: isSortable,
          textAlign: column.textAlign,
          stickyFirstColumn: stickyFirstColumn,
          onClick: function onClick() {
            return isSortable && _this2.setSortingKey(column.key, column.sortOptions);
          },
          isCompact: isCompact,
          isAlternateDesign: isAlternateDesign
        }, column.renderHeaderCell ? column.renderHeaderCell(column.longLabel ? /*#__PURE__*/React__default.createElement(componentsTitletooltip.TitleTooltip, {
          id: column.key,
          tip: column.longLabel
        }, column.label) : column.label) : column.longLabel ? /*#__PURE__*/React__default.createElement(componentsTitletooltip.TitleTooltip, {
          id: column.key,
          tip: column.longLabel
        }, column.label) : column.label);
      }))), !!data.length && !isLoading && /*#__PURE__*/React__default.createElement("tbody", null, sortedRows.map(function (row, index) {
        var lastRow = data.length - 1 === index;
        var rowKey = keyExtractor(row.rowContent) || index;
        return /*#__PURE__*/React__default.createElement(TableRow, {
          key: rowKey,
          rowContent: row.rowContent,
          columns: columns,
          isOpen: row.collapsibleRow && _this2.state.openRows.includes(data.findIndex(function (element) {
            return element.collapseData === row.rowContent;
          })),
          rowKey: rowKey,
          stickyFirstColumn: stickyFirstColumn,
          collapseHandler: _this2.collapseHandler,
          animateCollapse: _this2.state.animateCollapse,
          hideHeader: hideHeader,
          isLight: isLight,
          maxHeight: maxHeight,
          lastRow: lastRow,
          originalIndex: row.originalIndex,
          collapseData: !!row.collapseData,
          collapsibleRow: row.collapsibleRow,
          isCompact: isCompact,
          isAlternateDesign: isAlternateDesign
        });
      }))))), !data.length && !isLoading && /*#__PURE__*/React__default.createElement(EmptyView, {
        renderEmpty: renderEmpty,
        labelEmpty: labelEmpty,
        iconEmpty: iconEmpty
      }), isLoading && /*#__PURE__*/React__default.createElement(TableLoading, null));
    }
  }]);
}(React__default.Component);
Table.propTypes = {
  /** An array of objects containing all the config options for each column. For a list of all config options, refer to the proptypes : https://gitlab.bankassembly.com/shared-libraries/shared-components/blob/master/src/scopes/table/src/Table/Table.jsx */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /** Define a 'key' for accessing the correct data  */
    key: PropTypes.string.isRequired,
    /** Sets the header label (optional) */
    label: PropTypes.string,
    /** Sets ellipsis for text-wrapping (optional) */
    ellipsis: PropTypes.bool,
    /** function to custom render header cell */
    renderHeaderCell: PropTypes.func,
    /** function to custom render cell, with parameters: value, row. (optional) */
    renderCell: PropTypes.func,
    /** function to pass a style object to the <td> element, with parameters: value, row. (optional)  */
    style: PropTypes.func,
    /** Sets the text-alignement to the given value (optional) */
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    /** Sets the width of the column (optional). Only to use when basic table-layout or fixed does not suffice!  */
    width: PropTypes.string,
    /** Sets the column as sortable (optional) */
    isSortable: PropTypes.bool,
    /** Sets the sortOptions for the column (optional) */
    sortOptions: PropTypes.shape({
      /** compareFunction to use. You can provide your own in the form of (a,b) => {} */
      compareFunction: PropTypes.func,
      /** Sets sortingOrder to descending (optional) */
      desc: PropTypes.bool
    }),
    /** Hiddes the column out of the table (optional) */
    isHidden: PropTypes.bool
  })),
  /** Data that is used in the table. Each key in the children's object should correspond to the keys sets in the 'columns' prop, except for 'collapseData' which can contain extra JSX, and 'expandedDefault' which expects a boolean */
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  /** Default active sorted column, indicated by the key of that column */
  sortedOn: PropTypes.string,
  /** Indicates the loading state of the table */
  isLoading: PropTypes.bool,
  /** Visually hide the table header, while keeping them in the DOM for a11y */
  hideHeader: PropTypes.bool,
  /** Sets the key to be used in the mappings (if none is present index is used)  */
  keyExtractor: PropTypes.func,
  /** Sets the text for an empty table  */
  labelEmpty: PropTypes.string,
  /** Set a max-height on the table, in any unit type */
  maxHeight: PropTypes.string,
  /** Sets the icon above the text for an empty table  */
  iconEmpty: PropTypes.oneOf(['img_search', 'img_noResults', 'img_fileBroken']),
  /** Sets a custom renderer for the empty state of a table */
  renderEmpty: PropTypes.func,
  /** Sets the table to table-layout: fixed */
  fixed: PropTypes.bool,
  /** Default active sorted column order, indicated by boolean, true for DESC */
  sortedDesc: PropTypes.bool,
  /** Returns the rowIndex to the parent when a collapse has been triggered in order to allow some custom behaviors */
  onCollapse: PropTypes.func,
  /** Returns the sortingKey and sortDesc to the parent when the sorting of the table changes */
  onSortChange: PropTypes.func,
  /** Make the first column sticky */
  stickyFirstColumn: PropTypes.bool,
  /** Make the table in "light simple" mode */
  isLight: PropTypes.bool,
  /** Make header sticky (only works in combination with prop maxHeight) */
  stickyHeader: PropTypes.bool,
  /** Set to true if you want all collapsible content to be visible by default */
  expanded: PropTypes.bool,
  /** Set this to true if your project is using styled-components V4 or above */
  styledComponentsV4: PropTypes.bool,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** Set table compact mode (less padding, font size smaller) */
  isCompact: PropTypes.bool
};
Table.defaultProps = {
  isLoading: false,
  keyExtractor: function keyExtractor() {},
  labelEmpty: 'No data found',
  iconEmpty: null,
  fixed: false,
  isLight: false,
  sortedDesc: undefined,
  collapseData: undefined,
  onSortChange: function onSortChange() {},
  onCollapse: function onCollapse() {}
};
exports.Table = Table;
exports.Sortable = sortable;